import { Link } from "@inertiajs/react"
import { cn } from "@/lib/utils"

const TABS = [
  { key: "channels",   href: "/settings/channels",   label: "Channels" },
  { key: "api_tokens", href: "/settings/api_tokens", label: "API tokens" },
] as const

export type SettingsTabKey = (typeof TABS)[number]["key"]

export function SettingsSubNav({ active }: { active: SettingsTabKey }) {
  return (
    <nav className="flex flex-wrap items-end gap-6 border-b border-hairline">
      {TABS.map((tab) => {
        const isActive = tab.key === active
        return (
          <Link
            key={tab.href}
            href={tab.href}
            className={cn(
              "-mb-px border-b-2 px-1 py-3 text-sm no-underline",
              isActive
                ? "border-accent font-medium text-accent-display"
                : "border-transparent text-ink-body hover:text-ink-display",
            )}
          >
            {tab.label}
          </Link>
        )
      })}
    </nav>
  )
}
